<template>
  <div>
    cookie
    <button @click="sign">
      签名
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {usersign} from '@/contactLogic/swap/index.js';


export default {
     methods: {
        async sign(){
            const library= this.ethersprovider;
            const account = this.ethAddress;
          const msg= {name:'test',at:Date.now()};
          const  ucookie = await usersign(library,JSON.stringify(msg) ,account);
          console.log(ucookie);

         }
     },
    computed: {
        ...mapState(['web3', 'ethersprovider', 'ethChainID', 'ethAddress']),
        isReady() {
            return this.web3 && this.ethersprovider && this.ethChainID && this.ethAddress;
        }
        
    }

};
</script>

<style>

</style>